module.exports = "/_next/static/images/got-15-minutes-to-burn-small-8b98e72cf3516ffcfa7f5393d06282d9.png";